module.exports = __webpack_public_path__ + "static/media/invest.52fc6eaa.svg";